<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              :class="(!isVerticalMenuCollapsed || isMouseHovered) ? 'navbar-brand' : ''"
              to="/dashboard"
            >
              <!-- <span
                v-if="!isVerticalMenuCollapsed || isMouseHovered"
                class="brand-logo"
              >
                <b-img
                  :src="appLogoImage"
                  alt="Udara360 logo"
                />
              </span> -->
              <!-- <span
                v-else
                class="brand-logo d-flex align-items-center justify-content-center"
              >
                <b-img
                  :src="appLogoImageSm"
                  alt="Udara360 logo"
                  height="45%"
                  width="35%"
                />
              </span> -->
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <div
        v-if="!isVerticalMenuCollapsed || isMouseHovered"
        class="ml-2"
      >
        <!--filter -->
        <InputField
          id="search"
          v-model="searchQuery"
          label=""
          placeholder="Search"
          type="text"
        />

      <!--filter -->
      </div>

      <vertical-nav-menu-items
        :items="filteredMenuArray"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import { mapGetters } from 'vuex'
import navMenuItems from '@/navigation/vertical'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import InputField from '../../../../../views/forms/InputField.vue'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    // BImg,
    InputField,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    sideNavItems() {
      const filterItemsByFeature = items => items.reduce((filtered, item) => {
        if (item.enableFeature === true) {
          if (item.children && item.children.length > 0) {
            const children = filterItemsByFeature(item.children)
            if (children.length > 0) {
              filtered.push({ ...item, children })
            }
          } else {
            filtered.push(item)
          }
        }
        return filtered
      }, [])

      const features = filterItemsByFeature(navMenuItems)
      // const features = this.filterItemsByFeature(navMenuItems)
      const data = this.appsAndPages(features)
      const orderMenuItem = [...data].reduce((items, currentValue) => {
        if (currentValue.title === 'Dashboard') {
          currentValue.children.push({
            title: 'Dashboard',
            route: 'dashboard',
          })
          currentValue.children.push({
            title: 'Home',
            route: 'home',
          })
          return [currentValue, ...items]
        }
        return [...items, currentValue]
      }, [])
      return orderMenuItem
    },
    // ToDo: to refactor this function
    filteredMenuArray() {
      if (!this.searchQuery) {
        return this.sideNavItems
      }

      const data = []
      const elementData = []

      this.sideNavItems.forEach(sideNavItem => {
        sideNavItem.children.forEach(child => {
          if (child.title.toLowerCase().includes(this.searchQuery.toLowerCase())) {
            const da = data.find(x => x.title === sideNavItem.title)
            const a = {
              title: child.title,
              route: child.route,
              hasPermission: child.hasPermission,
            }

            if (da) {
              da.children = [...da.children, a]
            } else {
              data.push({
                title: sideNavItem.title,
                icon: sideNavItem.icon,
                children: [a],
              })
            }
          }

          if (child.children) {
            child.children.forEach(nestedChild => {
              if (nestedChild.title.toLowerCase().includes(this.searchQuery.toLowerCase())) {
                const elementDatafind = elementData.find(x => x.title === sideNavItem.title)
                const ba = {
                  title: nestedChild.title,
                  route: nestedChild.route,
                  hasPermission: nestedChild.hasPermission,
                }

                if (elementDatafind) {
                  if (!elementDatafind.children.children) {
                    elementDatafind.children.children = []
                  }
                  elementDatafind.children.children = [...elementDatafind.children.children, ba]
                } else {
                  elementData.push({
                    title: sideNavItem.title,
                    icon: sideNavItem.icon,
                    children: [
                      {
                        title: child.title,
                        route: child.route,
                        hasPermission: child.hasPermission,
                        children: [ba],
                      },
                    ],
                  })
                }
              }
            })
          }
        })
      })

      const finalData = data.filter(da => !elementData.some(ed => ed.title === da.title))

      return finalData.concat(elementData)
    },
  },
  methods: {
    appsAndPages(array) {
      if (this.userData !== null) {
        const getChildren = (result, object) => {
          if (this.userData.permissions.includes(object.hasPermission)) {
            result.push(object)
            return result.sort((a, b) => a.title.localeCompare(b.title))
          }
          if (Array.isArray(object.children)) {
            const children = object.children.reduce(getChildren, [])
            if (children.length) result.push({ ...object, children: children.sort((a, b) => a.title.localeCompare(b.title)) })
          }

          return result.sort((a, b) => a.title.localeCompare(b.title))
        }

        return array.reduce(getChildren, [])
      }
      return []
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage, appLogoImageSm } = $themeConfig.app

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      appLogoImageSm,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
.brand-logo-sm {
  width: 70px;
  height: 70px
}
</style>
